import {API_CONFIG} from './config';

export interface Ad {
  id: number;
  position: string;
  slot: number;
  image_url: string | null;
  target_url: string | null;
  sponsor_name: string | null;
}

interface AdsResponse {
  success: boolean;
  ads: Ad[];
}

/**
 * Fetch ads from the backend for the home screen
 * @param count Number of ads to fetch
 */
export const fetchAds = async (count: number = 10): Promise<Ad[]> => {
  try {
    const response = await fetch(`${API_CONFIG.API_URL}/app/ads?count=${count}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      console.log('Failed to fetch ads:', response.status);
      return [];
    }

    const data: AdsResponse = await response.json();
    return data.success ? data.ads : [];
  } catch (error) {
    console.log('Error fetching ads:', error);
    return [];
  }
};

export interface ArticleAds {
  header: Ad | null;
  afterFoto: Ad | null;
  inContent: Ad[];
  endArticle: Ad | null;
  afterForm: Ad | null;
  afterThirdComment: Ad | null;
  afterAllComments: Ad | null;
}

/**
 * Fetch ads for article page
 * Header + after-foto + in-content (cumulative 7-line) + end-article + comment ads
 */
export const fetchArticleAds = async (inContentCount: number = 10): Promise<ArticleAds> => {
  try {
    const response = await fetch(`${API_CONFIG.API_URL}/app/article-ads?count=${inContentCount}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      console.log('Failed to fetch article ads:', response.status);
      return {header: null, afterFoto: null, inContent: [], endArticle: null, afterForm: null, afterThirdComment: null, afterAllComments: null};
    }

    const data: AdsResponse = await response.json();
    if (!data.success) {
      return {header: null, afterFoto: null, inContent: [], endArticle: null, afterForm: null, afterThirdComment: null, afterAllComments: null};
    }

    // Separate ads by position
    const header = data.ads.find(ad => ad.position === 'APP_HEADER') || null;
    const afterFoto = data.ads.find(ad => ad.position === 'MOBILE_AFTER_IMAGE') || null;
    const inContent = data.ads.filter(ad => ad.position === 'MOBILE_IN_ARTICLE');
    const endArticle = data.ads.find(ad => ad.position === 'MOBILE_END_ARTICLE') || null;
    const afterForm = data.ads.find(ad => ad.position === 'MOBILE_BEFORE_COMMENTS') || null;
    const afterThirdComment = data.ads.find(ad => ad.position === 'MOBILE_AFTER_THIRD_COMMENT') || null;
    const afterAllComments = data.ads.find(ad => ad.position === 'MOBILE_AFTER_COMMENTS') || null;

    return {header, afterFoto, inContent, endArticle, afterForm, afterThirdComment, afterAllComments};
  } catch (error) {
    console.log('Error fetching article ads:', error);
    return {header: null, afterFoto: null, inContent: [], endArticle: null, afterForm: null, afterThirdComment: null, afterAllComments: null};
  }
};
